import { TutorialStep } from 'src/replicant/buruburu/tutorial/tutorial.ruleset';
import { showTutorial } from '../tutorial.util';
import { TutorialEvent } from '../TutorialController';
import { TutorialHandler } from './TutorialHandler';

export class ProfileTutorial implements TutorialHandler {
  public readonly step: TutorialStep = 'profile';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    if (event !== 'profilePopupOpened') return false;

    await showTutorial('profile', {
      $stepIndex: 8,
      $stepName: 'profile_popup',
    });

    return true;
  }
}
